import service from '@/request/service';

/**
 * 异议
 * pym
 * 异议列表以及互动 - 开始
 *
 * **/
// 异议全局权限
export function getOverAllButtonPermission(data) {
  return service({
    url: '/dissent/getOverAllButtonPermissions',
    method: 'get',
    params: data,
  });
}

// 发起异议
export function startDissent(data) {
  return service({
    url: '/dissent/startDissent',
    method: 'post',
    data,
  });
}

// 获取投标单位列表
export function getDissentBidderList(data) {
  return service({
    url: '/dissent/getDissentBidderListPage',
    method: 'post',
    data,
  });
}

// 获取标段下的异议数量
export function getBidderDissentCount(data) {
  return service({
    url: '/dissent/getDissentStateCounts',
    method: 'post',
    data,
  });
}

// 投标人点击有异议无异议
export function confirmDissent(data) {
  return service({
    url: 'dissent/confirmDissent',
    method: 'post',
    data,
  });
}

// 开标人结束异议
export function finishDissent(data) {
  return service({
    url: '/dissent/endDissent',
    method: 'post',
    data,
  });
}

// 获取投标人是否有异议
export function getBidderDissentState(data) {
  return service({
    url: '/dissent/getButtonPermissions',
    method: 'post',
    data,
  });
}

// 获取异议聊天列表
export function getBidderMsgList(data) {
  return service({
    url: '/dissent/getDissentMessageListByBidderId',
    method: 'post',
    data,
  });
}

// 开标人和投标人互发消息
export function sendDissentMessage(data) {
  return service({
    url: '/dissent/sendDissentMessage',
    method: 'post',
    data,
  });
}

// 已读未读消息
export function updateDissentMessageState(data) {
  return service({
    url: '/dissent/updateDissentMessageState',
    method: 'post',
    data,
  });
}

// 获取投标人bidderId集合
export function getBidderInfos(data) {
  return service({
    url: '/dissent/getBidderInfos',
    method: 'post',
    data,
  });
}

// 全局推送消息数量
export function getDissentBidSectionReply(data) {
  return service({
    url: '/dissent/getDissentBidSectionReply',
    method: 'post',
    data,
  });
}

/**
 * 异议
 * pym
 * 异议列表以及互动 - 结束
 *
 * **/
